import Vue from 'vue'
import App from './App.vue'
import store from './store'

import moneyFilter from './filters/money'
import pluralFilter from './filters/plural'

Vue.config.productionTip = false

Vue.filter('money', moneyFilter)
Vue.filter('plural', pluralFilter)

new Vue({
  store,
  render: h => h(App)
}).$mount('#print-calc')
